import { getDateTime } from "./get-date-time";
import { getLocalStringDate } from "./get-local-string-date";

const utcOffset = Math.abs(new Date().getTimezoneOffset() * 60000);

export const getDateWithOffset = (date: string): string => {
  const timeWithOffset = getDateTime(date) + utcOffset;

  return getLocalStringDate(new Date(timeWithOffset));
};
